import { Reveal } from "@components/ui";

const downloadItems = [
  {
    title: "Company Profile",
    description: "Overview of GASIS services and operations",
    color: "#122d63",
  },
  {
    title: "High-resolution Logos",
    description: "Brand assets in SVG, PNG, and EPS formats",
    color: "#f03813",
  },
  {
    title: "Management Photos",
    description: "Official headshots of leadership team",
    color: "#1a7a4f",
  },
];

export default function MediaPressSection() {
  return (
    <section className="relative w-full bg-white overflow-hidden">
      <div className="py-12 md:py-16 lg:py-[120px] px-5 md:px-10 lg:px-[180px]">
        <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-16 md:gap-20">
          {/* Part 1: Media & Press Enquiries */}
          <div className="flex flex-col gap-8 md:gap-12">
            <Reveal>
              <div className="flex flex-col items-center text-center mb-2">
                <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/10 text-[#122d63] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
                  Press & Media
                </span>
                <h2 className="text-[28px] md:text-[44px] lg:text-[60px] font-semibold text-[#122d63] tracking-[-0.04em]">
                  Media & Press Enquiries
                </h2>
                <p className="text-[18px] md:text-[22px] lg:text-[28px] text-[#62636c] tracking-[-0.04em] mt-3 max-w-[700px]">
                  For journalists, partners, and media outlets seeking
                  information about GASIS.
                </p>
              </div>
            </Reveal>

            {/* Contact Cards */}
            <Reveal>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {/* Email Card */}
                <div className="group relative overflow-hidden rounded-[24px] border border-[rgba(98,99,108,0.15)] bg-white p-6 md:p-8 hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:border-[#122d63]/20 transition-all duration-300">
                  <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full bg-[#122d63]/[0.04] group-hover:scale-150 transition-transform duration-500" />
                  <div className="relative z-10 flex items-start gap-4">
                    <div className="w-12 h-12 rounded-[14px] bg-[#122d63]/10 flex items-center justify-center shrink-0">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#122d63"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="2" y="4" width="20" height="16" rx="2" />
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                      </svg>
                    </div>
                    <div className="flex flex-col gap-1">
                      <span className="text-[14px] md:text-[16px] text-[#62636c] tracking-[-0.02em]">
                        Email
                      </span>
                      <span className="text-[20px] md:text-[24px] lg:text-[28px] font-semibold text-[#090d2c] tracking-[-0.04em]">
                        press@gasis.ae
                      </span>
                    </div>
                  </div>
                </div>

                {/* Phone Card */}
                <div className="group relative overflow-hidden rounded-[24px] border border-[rgba(98,99,108,0.15)] bg-white p-6 md:p-8 hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:border-[#122d63]/20 transition-all duration-300">
                  <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full bg-[#f03813]/[0.04] group-hover:scale-150 transition-transform duration-500" />
                  <div className="relative z-10 flex items-start gap-4">
                    <div className="w-12 h-12 rounded-[14px] bg-[#f03813]/10 flex items-center justify-center shrink-0">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#f03813"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                      </svg>
                    </div>
                    <div className="flex flex-col gap-1">
                      <span className="text-[14px] md:text-[16px] text-[#62636c] tracking-[-0.02em]">
                        Phone
                      </span>
                      <span className="text-[20px] md:text-[24px] lg:text-[28px] font-semibold text-[#090d2c] tracking-[-0.04em]">
                        800-GASIS (42747)
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Part 2: Media Kit Downloads */}
          <div className="flex flex-col gap-8 md:gap-12">
            <Reveal>
              <div className="flex flex-col items-center text-center">
                <span className="inline-block px-4 py-1.5 rounded-full bg-[#f03813]/10 text-[#f03813] text-[14px] md:text-[16px] font-medium tracking-[-0.04em] mb-4">
                  Resources
                </span>
                <h2 className="text-[28px] md:text-[44px] lg:text-[60px] font-semibold text-[#122d63] tracking-[-0.04em]">
                  Media Kit Downloads
                </h2>
              </div>
            </Reveal>

            {/* Download Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {downloadItems.map((item, index) => (
                <Reveal key={item.title} className="h-full" delay={index * 80}>
                  <div className="group relative overflow-hidden rounded-[24px] border border-[rgba(98,99,108,0.15)] bg-white p-5 md:p-6 h-full cursor-pointer hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300">
                    {/* Colored top accent */}
                    <div
                      className="absolute top-0 left-0 right-0 h-1"
                      style={{ backgroundColor: item.color }}
                    />

                    <div className="flex flex-col gap-4">
                      {/* Icon */}
                      <div
                        className="w-14 h-14 rounded-[16px] flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
                        style={{ backgroundColor: `${item.color}15` }}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke={item.color}
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                          <line x1="16" y1="13" x2="8" y2="13" />
                          <line x1="16" y1="17" x2="8" y2="17" />
                        </svg>
                      </div>

                      {/* Text */}
                      <div>
                        <h3 className="text-[18px] md:text-[20px] lg:text-[22px] font-semibold text-[#090d2c] tracking-[-0.04em] mb-1">
                          {item.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] text-[#62636c] tracking-[-0.02em]">
                          {item.description}
                        </p>
                      </div>

                      {/* Download link */}
                      <span
                        className="inline-flex items-center gap-1.5 text-[14px] font-medium transition-colors duration-200"
                        style={{ color: item.color }}
                      >
                        Download
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="transition-transform duration-200 group-hover:translate-y-0.5"
                        >
                          <path d="M12 5v14M5 12l7 7 7-7" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>

            {/* Download Full Kit */}
            <Reveal>
              <div className="flex justify-center">
                <button className="group flex items-center gap-3 bg-[#090d2c] hover:bg-[#122d63] text-white rounded-full py-3.5 pl-7 pr-3 shadow-[0_4px_16px_rgba(9,13,44,0.3)] hover:shadow-[0_6px_24px_rgba(9,13,44,0.4)] transition-all duration-300">
                  <span className="text-[17px] md:text-[20px] font-medium tracking-[-0.02em]">
                    Download Full Media Kit
                  </span>
                  <span className="flex items-center justify-center w-[40px] h-[40px] rounded-full bg-[#f03813] group-hover:bg-[#ff4d2b] transition-colors duration-300">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="transition-transform duration-300 group-hover:translate-y-0.5"
                    >
                      <path d="M12 5v14M5 12l7 7 7-7" />
                    </svg>
                  </span>
                </button>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
